export default {
  labels: {
    free_items: 'Artigos gratuitos',
    bogo: 'Leve 2, Pague 1',
    order_again: 'Repetir pedido',
  },
};
